import { Button, Form, Input } from "antd";
import PropTypes from "prop-types";

const AddCarCompany = ({
    t,
    selectedCompany,
    setSelectedCompany,
    setIsManualCarAddMode,
    setSelectedCarModel,
    hideAutomateButton = false,
}) => (
    <div>
        {!hideAutomateButton ? (
            <div className="flex justify-center items-center flex-col mb-8">
                <Button onClick={() => setIsManualCarAddMode(false)}>{t("addCarAutomateBtn")}</Button>
            </div>
        ) : null}

        <p className="text-md font-medium mb-2">{t("carCompany")}</p>
        <Form.Item>
            <Input
                placeholder={t("carCompany")}
                value={selectedCompany}
                onChange={(e) => {
                    setSelectedCompany(e.target.value);
                    setSelectedCarModel((prev) => ({
                        ...prev,
                        make: e.target.value,
                    }));
                }}
            />
        </Form.Item>
    </div>
);

AddCarCompany.propTypes = {
    t: PropTypes.func.isRequired,
    selectedCompany: PropTypes.string.isRequired,
    setSelectedCompany: PropTypes.func.isRequired,
    setIsManualCarAddMode: PropTypes.func.isRequired,
    setSelectedCarModel: PropTypes.func.isRequired,
    hideAutomateButton: PropTypes.bool,
};

export default AddCarCompany;
